import React from 'react';

const PromptContext = React.createContext();

export default PromptContext;
